/* eslint-disable react/jsx-no-bind */
import React, { useContext, useState } from "react";
import Icon, { UpOutlined, LoadingOutlined } from "@ant-design/icons";
import { Spin, Tooltip } from "antd";
import { useSelector } from "react-redux";
import EngagedAI from "../../../../static/EngagedAi_trans_bg.svg";
import { UserContext } from "../../../amplify/authenticator-provider";
import { applicationUseCaseMapping, getApplicationUseCaseId } from "../../../library/utils";
import "./editor.css";
import { isAllLocationSelected } from "../../../library/helpers";
import { AI_RESPONSE_COPY } from "./aiResponse/constants";
import CustomizeAiResponse from "./aiResponse/CustomizeAiResponse";
import { setTextAiResponseHistoryId } from "../../../redux/slices/aiSlice";
import { CHANNEL_FILTER, sortTipsAndTones } from "../../../helpers/quickTipsAndTonesHelper";

const EMPTY_SELECTION = { quickTipIds: [], toneIds: [], additionalNote: "" };

// Resolve a single active location id for per-location preferences.
const resolveLocationId = user =>
  Number(String(sessionStorage.getItem("currentLocationId") || "").split(",")[0]) ||
  user?.location?.id ||
  undefined;

export function SuggestAMessageButton({
  createSuggestedResponse,
  misc,
  selectedLead,
  disabled,
  text,
  setinputText,
  setloaderFn,
  postId = null,
  socialReviewId = null,
  code = null,
  selectedOppTypeId = null,
}) {
  const { user } = useContext(UserContext);
  const [customizePromptData, setcustomizePromptData] = useState(EMPTY_SELECTION);

  const { applicationUseCases } = useSelector(state => state.aiData);
  const { messageOpportunity } = useSelector(state => state.lead);

  const useCaseKey = code || applicationUseCaseMapping.ENGAGEMENT_MESSAGE_SUGGESTION;
  const resolvedUseCaseId = getApplicationUseCaseId(applicationUseCases, useCaseKey)?.id;
  const locationId = resolveLocationId(user);
  // This surface has no opp-type tab, so department derivation stays on the
  // legacy user.departmentIds path.
  // const selectedOppTypeId = null;

  const quickTipVariables = {
    companyId: user?.company?.id,
    locationIds:
      !selectedOppTypeId && Array.isArray(user?.departmentIds) && user.departmentIds.length > 0
        ? null
        : !isAllLocationSelected()
        ? sessionStorage.getItem("currentLocationId")
        : isAllLocationSelected()
        ? user?.location?.id
        : null,
    applicationUseCaseId: resolvedUseCaseId,
    departmentIds: selectedOppTypeId ? null : user?.departmentIds || null,
    rootOppTypeId: selectedOppTypeId || null,
  };

  const buildResponsePayload = promptData => ({
    aiSuggestionUserInput: { ...promptData },
    leadId: selectedLead?.id,
    companyId: user?.company?.id,
    applicationUseCaseId: resolvedUseCaseId,
    postId,
    socialReviewId,
    leadOpportunityId: messageOpportunity === "#DEFAULTOPPID" ? null : +messageOpportunity,
  });

  return (
    <>
      {misc.loading && <Spin indicator={<LoadingOutlined spin />} className="m-1" />}
      <div
        key={selectedLead?.id}
        className="flex bg-white border border-solid border-[#E2E8F0] rounded flex-row items-stretch"
        style={{
          opacity: disabled || misc.loading ? 0.5 : 1,
          pointerEvents: disabled || misc.loading ? "none" : "auto",
        }}
      >
        <Tooltip title={AI_RESPONSE_COPY.GENERATE_TOOLTIP} disabled={misc.loading}>
          <div
            className="flex items-center justify-center w-[30px] h-[30px] cursor-pointer"
            onClick={() => {
              if (text?.current) {
                setinputText && setinputText("");
                text.current.placeholder = "Generating response...";
                text.current.value = "";
                text.current.style.height = "0px";
                text.current.focus();
              }
              !misc.loading && createSuggestedResponse();
            }}
          >
            <Icon component={EngagedAI} alt="EngagedAi" style={{ fontSize: "20px" }} />
          </div>
        </Tooltip>
        <div className="self-stretch w-[1px] bg-[#E2E8F0]" />
        <CustomizeAiResponse
          user={user}
          locationId={locationId}
          applicationUseCaseId={resolvedUseCaseId}
          quickTipVariables={quickTipVariables}
          buildResponsePayload={buildResponsePayload}
          text={text}
          setInputText={setinputText}
          setLoader={setloaderFn}
          value={customizePromptData}
          onChange={setcustomizePromptData}
          renderTrigger={({ open }) => (
            <Tooltip title={AI_RESPONSE_COPY.CUSTOMIZE_TOOLTIP}>
              <div className="flex items-center justify-center w-[30px] h-[30px] cursor-pointer">
                <UpOutlined
                  className={`text-[#64748B] text-[14px] ${
                    open ? "rotate-0" : "rotate-180"
                  } transition duration-300`}
                />
              </div>
            </Tooltip>
          )}
        />
      </div>
    </>
  );
}
